import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { of, Subscription } from 'rxjs';
import { FinalClientService } from '../../../../account/services/final-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first, map, switchMap } from 'rxjs/internal/operators';
import { PlaceDetailsElectricity } from "../../../../account/models/PlaceDetailsElectricity";
import { CountyDTO } from "../../../../shared/models/CountyDTO";
import { CityDTO } from "../../../../shared/models/CityDTO";
import { AddressService } from "../../../../shared/services/address.service";

@Component({
  selector: 'app-electricity-place-details',
  templateUrl: './electricity-consumption-place-details.component.html',
  styleUrls: ['./electricity-consumption-place-details.component.scss']
})
export class ElectricityConsumptionPlaceDetailsComponent implements OnInit, OnDestroy {


  public form: FormGroup;
  public conventionParts: string[] = [];
  public suppliers: string[] = [];
  private routeDataSub: Subscription;
  public placeId: number;
  public isFormSubmitAttempt = false;
  public placeDetails: PlaceDetailsElectricity;
  public counties: CountyDTO[] = [];
  public cities: CityDTO[] = [];

  @Input()
  public editable: boolean = false;

  @Input()
  set place(place: any) {
    this.form.patchValue(place);
    this.conventionParts = place.conventionParties;
    this.suppliers = place.suppliers;
  }

  @Input()
  public isContractChange: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private finalClientService: FinalClientService,
    private route: ActivatedRoute,
    private addressService: AddressService
  ) {
    this.createConsumptionPlaceForm();
  }

  createConsumptionPlaceForm() {
    this.form = this.formBuilder.group({
      operatorName: ['', Validators.required],
      code: ['', Validators.required],
      placeType: [''],
      isProsumer: ['', Validators.required],
      conventionParties: [''],
      suppliers: [''],
      //  address
      streetNumber: ['', Validators.required],
      streetName: ['', Validators.required],
      postalCode: ['', Validators.required],
      block: [''],
      apartment: [''],
      floor: [''],
      county: ['', Validators.required],
      city: ['', Validators.required],
      //convention
      conventionType: [''],
      conventionNumber: [''],
      conventionDate: [''],
      conventionPresent: [''],
      //technical data
      approvedConsumptionPower: ['', Validators.required],
      voltageLevel: ['', Validators.required],
      smartMeter: ['', Validators.required],
      counterIndexInterval: ['', Validators.required],
      counterIndexDesc: ['', Validators.required],
      counterIndexValue: [''],
      counterIndexReadDate: [''],
      counterSeries: ['', Validators.required],
      counterType: ['', Validators.required],
      connectionType: ['', Validators.required],
      technicalDataStatus: ['', Validators.required],
      networkType: ['', Validators.required],
      operatingMode: ['', Validators.required],
      //network contract
      clientIdentificationNumber: [''],
      clientName: [''],
      contractNumber: [''],
      validFrom: [''],
      validTo: [''],
      contractType: [''],
      //connection certificate
      connectionCertificate: [''],
      connectionCertificateNumber: [''],
      connectionCertificateDate: [''],
      //connection notice
      connectionNotice: [''],
      connectionNoticeNumber: [''],
      connectionNoticeDate: [''],

      //only for disable form
      isProsumerValue: [''],
      isNotProsumerValue: [''],
      isSmartMeterValue: [''],
      isNotSmartMeterValue: [''],
      isConsumptionPlaceConectedValue: [''],
      isConsumptionPlaceDisconectedValue: [''],
      isConsumptionPlaceInactiveValue: [''],
      isNetworkTypeDistributionValue: [''],
      isNetworkTypeTransportValue: [''],
      isOperatingModePermanentValue: [''],
      isOperatingModeSeasonalValue: [''],
      isConnectionTypeMonoValue: [''],
      isConnectionTypeTriValue: [''],
    });
  }

  disableForm(): void {
    if (!this.editable) {
      this.form.disable();
    }
  }

  ngOnInit() {
    this.routeDataSub = this.route
      .paramMap
      .pipe(
        map(value => {
          if (window.history.state.editable) {
            this.editable = !!window.history.state.editable;
          }
          this.placeId = +window.history.state.placeId;
          return this.placeId;
        })
      ).subscribe((validationDetails) => this.disableForm());

    if (this.placeId) {
      this.finalClientService.getFCElectricityConsumptionPlace(this.placeId).pipe(first())
        .subscribe(data => {
          this.form.patchValue(data);
          this.addressService.getCities(this.form.get('county').value).subscribe((cities: CityDTO[]) => this.cities = cities);
        });
    }
  }

  onSubmit(): void {
    this.isFormSubmitAttempt = true;
  }

  onChangeCounty() {
    this.cities = [];
    this.addressService.getCities(this.form.get('county').value).subscribe((cities: CityDTO[]) => this.cities = cities);
  }

  isConventionPresent(): boolean {
    if (this.form.get('conventionPresent').value === null || this.form.get('conventionPresent').value === false) {
      return false;
    } else {
      return true;
    }
  }

  isNetworkTypeDistribution(): boolean {
    if (this.form.get('networkType').value === 'D')
      return true;
    else
      return false;
  }

  isNetworkTypeTransport(): boolean {
    if (this.form.get('networkType').value === 'T')
      return true;
    else
      return false;
  }

  isConsumptionPlaceConnected(): boolean {
    if (this.form.get('technicalDataStatus').value === 'CONECTAT')
      return true;
    else
      return false;
  }

  isConsumptionPlaceDisconnected(): boolean {
    if (this.form.get('technicalDataStatus').value === 'DECONECTAT')
      return true;
    else
      return false;
  }

  isConsumptionPlaceDezafectat(): boolean {
    if (this.form.get('technicalDataStatus').value === 'DEZAFECTAT')
      return true;
    else
      return false;
  }

  isConsumptionPlaceInactive(): boolean {
    if (this.form.get('technicalDataStatus').value === 'INACTIV')
      return true;
    else
      return false;
  }

  isSmartMeter(): boolean {
    if (this.form.get('smartMeter').value === null || this.form.get('smartMeter').value === false) {
      return false;
    } else {
      return true;
    }
  }

  isNotSmartMeter(): boolean {
    if (this.form.get('smartMeter').value === null || this.form.get('smartMeter').value === true) {
      return false;
    } else {
      return true;
    }
  }

  isOperatingModeSeasonal(): boolean {
    if (this.form.get('operatingMode').value === 'SEZONIER')
      return true;
    else
      return false;
  }

  isOperatingModePermanent(): boolean {
    if (this.form.get('operatingMode').value === 'PERMANENT')
      return true;
    else
      return false;
  }

  isConnectionTypeMono(): boolean {
    if (this.form.get('connectionType').value === 'MONOFAZAT')
      return true;
    else
      return false;
  }

  isConnectionTypeTri(): boolean {
    if (this.form.get('connectionType').value === 'TRIFAZAT')
      return true;
    else
      return false;
  }

  isProsumer(): boolean {
    if (this.form.get('isProsumer').value === null || this.form.get('isProsumer').value === false) {
      return false;
    } else {
      return true;
    }
  }

  setProsumer(value): void {
    this.form.controls['isProsumer'].setValue(value);
  }

  setSmartMeter(value): void {
    this.form.controls['smartMeter'].setValue(value);
  }

  setTechnicalDataStatus(value): void {
    this.form.controls['technicalDataStatus'].setValue(value);
  }

  setConnectionType(value): void {
    this.form.controls['connectionType'].setValue(value);
  }

  setNetworkType(value): void {
    this.form.controls['networkType'].setValue(value);
  }

  setOperatingMode(value): void {
    this.form.controls['operatingMode'].setValue(value);
  }

  ngOnDestroy(): void {
    this.routeDataSub.unsubscribe();
  }

}
